<script>
import Multiselect from "vue-multiselect";
import PageImage from "../pages/page-image";
import api from "../../services/api";

/**
 * Nav-bar Component
 */
export default {
  components: {
    Multiselect,
    PageImage,
  },
  props: {
    album: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      singleImage: false,
      isLoading: false,
      listPages: [],
    };
  },
  mounted() {
    this.getPages();
  },
  methods: {
    async getPages() {
      this.isLoading = true;

      if (this.album.pages === undefined) {
        this.album.pages = await api.get('pages', {
          page: 1,
          length: 300,
          sortBy: 'NumPageAlbum',
          sortDir: 'asc',
          albums: this.album.id
        }).then((response) => {
          return response.data.data;
        });
      }

      this.setListPages();
      this.isLoading = false;
    },
    setListPages() {
      for (const page in this.album.pages) {
        if (this.album.pages.hasOwnProperty(page))
          this.listPages.push(this.album.pages[page].NumPageAlbum);
      }
    },
    getImageFromNumPageAlbum(numPageAlbum) {
      let pageFound = null;

      for (const page in this.album.pages) {
        if (this.album.pages.hasOwnProperty(page) && this.album.pages[page].NumPageAlbum === numPageAlbum) {
          pageFound = this.album.pages[page];
          break;
        }
      }

      return pageFound;
    },
  }
};
</script>

<template>
  <b-card no-body class="mb-0">
    <b-row no-gutters class="align-items-center me-0">
      <b-col md="3" class="text-center">
        <page-image :page="getImageFromNumPageAlbum(album.thumbnails)"></page-image>
      </b-col>
      <b-col md="9" class="p-0">
        <b-card-body>
          <b-row class="mb-3">
            <b-col md="3">
              <b-form-group label="Numéro d'inventaire" :label-for="`formrow-num_inventaire-input_${album.id}`">
                <b-form-input :id="`formrow-num_inventaire-input_${album.id}`" type="text"
                              v-model="album.num_inventaire"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Titre" :label-for="`formrow-titre-input_${album.id}`">
                <b-form-input :id="`formrow-titre-input_${album.id}`" type="text" v-model="album.nom_volume"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col>
              <b-form-group label="Page d'illustration" :label-for="`formrow-thumbnails_album-input_${album.id}`">
                <multiselect
                    :id="`formrow-thumbnails_album-input_${album.id}`"
                    v-model="album.thumbnails"
                    :options="listPages"
                    :loading="isLoading"
                    :show-labels="false"
                >
                </multiselect>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
</template>
